import { z } from "zod";
import { Id, IsoDateTime } from "./common.ts";

export const TableStatus = z.enum(["available", "occupied", "reserved", "disabled"]);
export type TableStatus = z.infer<typeof TableStatus>;

export const Table = z.object({
  id: Id,
  venueId: Id,
  code: z.string().min(1),
  label: z.string().min(1),
  capacity: z.number().int().positive().default(4),
  status: TableStatus,
  /** Layout coordinates for the owner floor-plan editor. */
  x: z.number().optional(),
  y: z.number().optional(),
  createdAt: IsoDateTime,
});
export type Table = z.infer<typeof Table>;

/** Payload encoded in the table QR code that the customer scans to check in. */
export const TableQrPayload = z.object({
  venueId: Id,
  tableId: Id,
  code: z.string().min(1),
});
export type TableQrPayload = z.infer<typeof TableQrPayload>;
